module.exports = __webpack_public_path__ + "img/fatmap.e28c6e24.png";